import ApiAberta from "../ApiAberta"
import ApiWebAgenda from "../ApiWebAgenda";


const verificaEmpresa = async (urlEmpresa) => {


    try {
        const { data } = await ApiAberta.post('/website/verificaEmpresa', { nome: urlEmpresa })
        return data;
    } catch (error) {
        //console.log(error)
    }

}

const getTiposServicos = async (empresaId, filtros) => {

    let paramsPost = {}
    paramsPost.empresaId = empresaId

    if (filtros?.withServicosOnline != undefined) {
        paramsPost.withServicosOnline = filtros.withServicosOnline
    }
    if (filtros?.showServicos != undefined) {
        paramsPost.showServicos = filtros.showServicos
    }


    try {
        const { data } = await ApiAberta.post('/website/getTiposServicos', paramsPost)
        return data;
    } catch (error) {
        //console.log(error)
    }

}


const getBuscaHorariosDisponiveis = async (empresaId, filtros) => {

    let paramsPost = {}
    paramsPost.empresaId = empresaId

    if (filtros?.data != undefined) {
        paramsPost.data = filtros.data
    }
    if (filtros?.tipoBusca != undefined) {
        paramsPost.tipoBusca = filtros.tipoBusca
    }
    if (filtros?.servicosId != undefined) {
        paramsPost.servicosId = filtros.servicosId
    }

    try {
        const { data } = await ApiAberta.post('/website/getHorariosDisponiveis', paramsPost)
        return data;
    } catch (error) {
        //console.log(error)
    }

}
const registrarCliente = async (dadosCliente) => {

    try {
        const { data } = await ApiAberta.post('/website/clientes/register', dadosCliente)
        return data;
    } catch (error) {
        //console.log(error)
    }

}
const loginCliente = async (empresaId, dadosCliente) => {
    try {
        dadosCliente.empresasId = empresaId
        const { data } = await ApiAberta.post('/website/clientes/login', dadosCliente)
        return data;
    } catch (error) {
        //console.log(error)
    }
}

const storeAgendamento = async ( dadosCliente) => {
    try {
        const { data } = await ApiWebAgenda.post('/website/agendamentos', dadosCliente)
        return data;
    } catch (error) {
        //console.log(error)
    }
}

export const WebsiteAgendamentoService = {
    verificaEmpresa,
    getTiposServicos,
    getBuscaHorariosDisponiveis,
    registrarCliente,
    loginCliente,
    storeAgendamento
    
}